import isNil from 'lodash/isNil'
const state = {
    period: null,
    periodFilter: false,
    user: null,
    search: null,
    customers: []
};

const getters = {
    isPeriodFilterActive: (state) => (fallback) => {
        return !isNil(state.periodFilter) ? state.periodFilter : fallback
    },
    getPeriod: (state) => (fallback) => {
        return !isNil(state.period) ? state.period : fallback
    },
    getUser: (state) => (fallback) => {
        return !isNil(state.user) ? state.user : fallback
    },
    getSearch: (state) => (fallback) => {
        return !isNil(state.search) ? state.search : fallback
    },
    getCustomers: (state) => (fallback) => {
        return !isNil(state.customers) && state.customers.length ? state.customers : fallback
    },
};

const mutations = {
    setPeriod: (state, payload) => {
        state.period = payload;
    },
    setPeriodFilterActive: (state, payload) => {
        state.periodFilter = payload;
    },
    setUser: (state, payload) => {
        state.user = payload;
    },
    setSearch: (state, payload) => {
        state.search = payload;
    },
    setCustomers: (state, payload) => {
        state.customers = payload;
    }
};

// if This will not work we will need to save it in a constant Namespace
export default {
    namespaced: true,
    state,
    getters,
    mutations
};
